import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgLockShield = function SvgLockShield(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_19_420)",
        fillOpacity: 0.16,
        d: "M20.833 40.439v-14.52q0-1.496.835-2.693a4.8 4.8 0 0 1 2.159-1.736l18.718-6.93q.852-.332 1.622-.333.769 0 1.621.334l18.718 6.93q1.324.538 2.16 1.735.834 1.197.834 2.694v14.518q0 10.629-5.82 19.633T45.816 72.862q-.36.167-.783.25-.422.084-.866.084t-.866-.084a3.4 3.4 0 0 1-.783-.25q-10.044-3.789-15.864-12.791-5.82-9.005-5.82-19.632"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_420)",
        d: "M16.667 36.718v-14.52q0-1.496.834-2.693a4.8 4.8 0 0 1 2.16-1.736l18.717-6.93q.854-.332 1.622-.332t1.622.333l18.718 6.93q1.323.538 2.158 1.735t.835 2.694v14.519q0 10.629-5.82 19.631-5.82 9.005-15.864 12.792-.36.167-.783.25-.422.084-.866.084t-.866-.084a3.4 3.4 0 0 1-.783-.25Q28.31 65.352 22.487 56.35q-5.82-9.003-5.82-19.631M40 67.122q9.07-2.91 14.92-11.414t5.85-18.97V22.134a2 2 0 0 0-.353-1.154 2.13 2.13 0 0 0-.994-.77L40.705 13.2A1.9 1.9 0 0 0 40 13.07q-.385 0-.705.128l-18.718 7.013q-.642.256-.994.769a2 2 0 0 0-.352 1.154v14.602q0 10.469 5.849 18.971Q30.93 64.213 40 67.122M33.077 52.18h13.846q.981 0 1.644-.664.664-.663.664-1.644V39.359q0-.981-.664-1.644-.663-.664-1.644-.664h-.962v-3.333q0-2.492-1.701-4.196-1.703-1.701-4.196-1.701t-4.196 1.701q-1.701 1.703-1.701 4.196v3.333h-1.09q-.981 0-1.644.664-.664.663-.664 1.644v10.513q0 .981.664 1.644.663.663 1.644.664m3.27-15.129v-3.333q0-1.538 1.089-2.567t2.628-1.03 2.628 1.035 1.09 2.562v3.333z"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_420",
        x1: 21.321,
        x2: 66.85,
        y1: 43.711,
        y2: 43.711,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_420",
        x1: 17.154,
        x2: 62.684,
        y1: 39.99,
        y2: 39.99,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgLockShield as ReactComponent };
//# sourceMappingURL=LockShield.svg.es.js.map
